// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenu-cls1_f87","cls2":"AccountMenu-cls2_s8S AccountMenu-cls1_f87"};